import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

import { renderInstructorPage } from './-route-wrappers';

const CourseFeedback = lazyRouteComponent(() => import('@/_instructor/course-feedback'));

export const Route = createFileRoute('/_instructor/course-feedback')({
  component: () => renderInstructorPage(CourseFeedback),
});
